import { render, staticRenderFns } from "./ConnectWalletWC.vue?vue&type=template&id=e9a634a4&scoped=true"
import script from "./ConnectWalletWC.vue?vue&type=script&lang=ts"
export * from "./ConnectWalletWC.vue?vue&type=script&lang=ts"
import style0 from "./ConnectWalletWC.vue?vue&type=style&index=0&id=e9a634a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a634a4",
  null
  
)

export default component.exports